<template>
  <div id="app" v-cloak>
    <div id="nav" v-if="isAuthenticated">
      <div id="top">
        <router-link to="/">Home</router-link>
        <router-link to="/outgoing" v-if="canAccessThis('1')">Исх.</router-link>
        <router-link to="/incoming" v-if="canAccessThis('9')">Вход.</router-link>
        <router-link to="/clientService" v-if="canAccessThis('13')">Кл. сер.</router-link>
        <router-link to="/statsOutgoing" v-if="canAccessThis('4')">Реестр инфо</router-link>
        <router-link to="/myRequest" >Мои заявки</router-link>
<!--        <router-link to="/autoCC" v-if="canAccessThis('19')">Авто дозвон</router-link>-->
        <router-link to="/editIncome" v-if="canAccessThis('15')">Изм. вход.</router-link>
        <router-link to="/editScripts/1" v-if="canAccessThis('4')">Ред. Скриптов</router-link>


        <a href="#" v-on:click.prevent="finderShow" v-if="canAccessThis('2')" id="finderButton">Поиск</a>
      </div>
     <div id="bottom">
       <router-link to="/logout" >Выход</router-link>
     </div>
    </div>
    <router-view/>
    <modal v-show="showModal"></modal>
    <finder :showFlag="showFlag" v-on:closeFinder="closeFinder"></finder>
    <installPromts></installPromts>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {USER_REQUEST} from './store/actions/user'
  //todo проверить  cath на нормальный ввод ошибок из процедуры.
  export default {
    name: 'app',
    data:function(){
      return {
        showFlag:false
      }
    },
    created: function () {
      if (this.$store.getters.isAuthenticated) {
        this.$store.dispatch(USER_REQUEST)
      }

    },
    components: {
      modal: () => import('./components/Modal'),
      loader: () => import('@/components/loader'),
      finder: () => import('@/components/finder'),
      installPromts: () => import('@/components/installPromts'),
    },
    computed: {
      showModal() {
        return this.$store.state.modalFlag;
      },
      ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded','canAccessThis']),
    },
    methods:{
      finderShow:function(){
        this.showFlag = true;
      },
      closeFinder:function(){
        this.showFlag = false;
      }
    }
  }
</script>

<style>
  [v-cloak] > *{display: none;}
  [v-cloak]::before { content: "Собираем форму для вас"; margin: 1.5vw 2vw;
    background: white;
    border: 1px solid rgb(15,87,64);
    border-radius: 5px;
    padding: 2vw 2vw;display: block;text-align: center;}

  html, body ,p{
    margin: 0;
    padding: 0;

  }
  body{background: rgba(15, 87, 64, 0.11);color:black;}
label{font-size: 14px;}
  input, select{
    padding: 3px 10px;
    width: calc(100% - 22px);
    box-shadow: 0px 3px 8px 0px rgba(15, 87, 64, 0.47);
    margin: 0 0 10px 0;
    border-width: 1px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-size: 17px;
    height: 22px;
  }
  input[type=radio],  input[type=checkbox]{box-shadow: none;width: 15px;height: 15px;margin: 0;}
  select {width: 100%;height: 30px;}
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;

    display: flex;
    align-items:stretch;
    justify-content: flex-start;
    min-height: 100vh;
  }

  #nav {
    width: 70px;
    background: #2c3e50;
    display: flex;
    flex-direction: column;
    position: fixed;
    top:0;
    left:0;
    height: calc(100% - 80px);
    justify-content:space-between;
    z-index: 999;
    padding: 20px 0 60px;
  }
  #nav #top{display: flex;
    flex-direction: column;}
  #nav #bottom{display: flex;
    flex-direction: column;}

  #nav a {
    font-weight: bold;
    color:white;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }

  .borderBox{background: white;padding: 10px;margin: 10px 0 10px 90px;    border: 1px solid rgb(15,87,64);}

  h1,h2,h3 {margin: 5px;padding: 0;}
  div.button {padding: 6px 10px;
    border: 1px solid;
    color: white;
    background: rgb(15,87,64);
    transition: 0.3s ease-out;cursor: pointer;display: inline-block}
  div.button:hover{background: rgb(61,176,74);}


  .fl{display: flex;justify-content: space-between;}
  .threeInLine > div{width: 32%;}

  .frstShortSeconLong > div:first-child{width: 32%;}
  .frstShortSeconLong > div:last-child{width: 66%;}

  #top a{margin: 3px 0}
  #top a#finderButton{margin-top:100px;}
</style>


